import { render, staticRenderFns } from "./CancelDelivery.vue?vue&type=template&id=70db5366&scoped=true&"
import script from "./CancelDelivery.vue?vue&type=script&lang=js&"
export * from "./CancelDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CancelDelivery.vue?vue&type=style&index=0&id=70db5366&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db5366",
  null
  
)

export default component.exports